/**
 * Landing page shared constants: hero images, "how it works" steps, testimonials,
 * partner/driver/fleet join options and framer-motion variants.
 */
import { Search, CalendarCheck2, Sparkles, Building2, Car, Handshake } from "lucide-react";

export const HERO_SLIDES = [
  { src: "/images/hero-lisbon.png", alt: "Lisboa" },
  { src: "/images/hero-benagil.png", alt: "Benagil" },
  { src: "/images/hero-algarve.png", alt: "Algarve" },
  { src: "/images/hero-fatima.png", alt: "Fátima" },
];

// STEPS content is translated at render time — icons only kept here.
export const STEPS = [
  { icon: Search },
  { icon: CalendarCheck2 },
  { icon: Sparkles },
];

// Real reviews are intentionally NOT translated — keep in the original language written by the client.
export const TESTIMONIALS = [
  {
    name: "Sarah Mitchell",
    role: "Londres, UK",
    rating: 5,
    text: "Absolutely stunning experience. Our driver João was knowledgeable, friendly, and turned a simple transfer into a mini tour of Lisbon. The Mercedes was spotless. 10/10.",
  },
  {
    name: "François Dubois",
    role: "Paris, France",
    rating: 5,
    text: "Le tour privé à Sintra était magique. Ponctualité irréprochable, véhicule de luxe et un chauffeur qui parle français couramment. Nous reviendrons sans hésiter.",
  },
  {
    name: "Marco Silva",
    role: "São Paulo, Brasil",
    rating: 5,
    text: "Contratei a DiTours para dois dias em Lisboa e Sintra. Foi impecável do início ao fim. Preço justo, veículo elétrico Tesla e um guia apaixonado por Portugal. Recomendo!",
  },
];

// JOIN_OPTIONS — labels/titles are translated at render time via t().
export const JOIN_OPTIONS = [
  {
    key: "partner",
    icon: Building2,
    endpoint: "/signup/partner",
    fields: [
      { name: "company_name", labelKey: "join_field_company_name", required: true },
      { name: "nif", labelKey: "join_field_nif", required: true },
      {
        name: "type",
        labelKey: "join_field_type",
        type: "select",
        options: [
          { value: "hotel", labelKey: "join_field_type_hotel" },
          { value: "travel_agency", labelKey: "join_field_type_agency" },
        ],
        required: true,
      },
      { name: "contact_name", labelKey: "join_field_contact_name", required: true },
      { name: "email", labelKey: "join_field_email", type: "email", required: true },
      { name: "phone", labelKey: "join_field_phone", required: true },
      { name: "password", labelKey: "join_field_password", type: "password", required: true, minLength: 8 },
    ],
  },
  {
    key: "driver",
    icon: Car,
    endpoint: "/signup/driver",
    fields: [
      { name: "name", labelKey: "join_field_name", required: true },
      { name: "email", labelKey: "join_field_email", type: "email", required: true },
      { name: "phone", labelKey: "join_field_phone", required: true },
      { name: "license_number", labelKey: "join_field_license", required: true },
      { name: "password", labelKey: "join_field_password", type: "password", required: true, minLength: 8 },
    ],
  },
  {
    key: "fleet",
    icon: Handshake,
    endpoint: "/signup/fleet",
    fields: [
      { name: "company_name", labelKey: "join_field_company_name", required: true },
      { name: "nif", labelKey: "join_field_nif", required: true },
      { name: "legal_representative", labelKey: "join_field_legal_rep", required: true },
      { name: "email", labelKey: "join_field_email", type: "email", required: true },
      { name: "phone", labelKey: "join_field_phone", required: true },
      { name: "password", labelKey: "join_field_password", type: "password", required: true, minLength: 8 },
    ],
  },
];

// Framer Motion helpers
export const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};
export const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.05 } },
};

// Backend API base
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
